<template>
<nav class="navbar fixed-top navbar-expand-lg navbar-dark bg-dark">

  <button class="navbar-toggler" type="button" data-toggle="collapse"
          v-on:click="toggleMenu"
          data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown"
          aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <router-link class="navbar-brand"  to="/home" style="max-width: 70%">
    Don Marcelo
  </router-link>
  <router-link class="nav-link"  to="/map">
     <img src="../assets/glyph-iconset/si-glyph-pin-location-white.svg" width="30"/>
  </router-link>
  <div id="navbarNavDropdown" class="navbar-collapse"
       :class="{'collapse': collapsed}">
    <ul class="navbar-nav text-left">
      <li class="nav-item" :class="{'active': subIsActive('/home')}">
        <router-link class="nav-link" to="/home">Inicio</router-link>
      </li>
      <li class="nav-item" :class="{'active': subIsActive('/myOrders')}">
        <router-link class="nav-link"  to="/myOrders">Mis Ordenes</router-link>
      </li>
      <li class="nav-item" :class="{'active': subIsActive('/ordersToSend')}">
        <router-link class="nav-link"  to="/ordersToSend">Por Enviar</router-link>
      </li>
      <li class="nav-item" :class="{'active': subIsActive('/ordersToReceive')}">
        <router-link  class="nav-link" to="/ordersToReceive">Por Recoger</router-link>
      </li>
      <li class="nav-item" :class="{'active': subIsActive('/ordersObserved')}">
        <router-link  class="nav-link" to="/ordersObserved">Observadas</router-link>
      </li>
      <li class="nav-item" :class="{'active': subIsActive('/about')}">
        <router-link class="nav-link"  to="/coupons">Mis Cupones</router-link>
      </li>
      <li class="nav-item" :class="{'active': subIsActive('/map')}">
        <router-link  class="nav-link" to="/map">Ubícanos</router-link>
      </li>
      <li class="nav-item" :class="{'active': subIsActive('/logout')}">
        <router-link class="nav-link" to="/logout">Salir</router-link>
      </li>
    </ul>
  </div>
</nav>
</template>

<script>
export default{
  name: "NavBar",
  data: function(){
    return {
      collapsed: true
    }
  },
  methods: {
    toggleMenu: function(){
      this.collapsed = !this.collapsed;
    },
    subIsActive: function(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(path => {
        return this.$route.path.indexOf(path) === 0 // current path starts with this path string
      })
    },
  }
}
</script>

<style scoped>
.router-link-active{
    font-weight: bold;
}
.bg-dark{
    color: #ffffff;
    background-color: rgb(221, 100, 0) !important;
}
.navbar-light .navbar-brand {
    color: #ffffff;
}
</style>
